module.exports = __webpack_public_path__ + "static/st2-1-c9b3f0273f4538ae53a59d039ea35a88.jpg";